import o from"@emotion/styled";import{setColor as i,setPadding as r,setRadius as t}from"../../utils/generateStyles.js";const a=o.div`
  label: card;
  width: 100%;
  ${()=>i("white","backgroundColor")}
  ${d=>r(d.padding)}
  ${d=>t(d.radius)}
`;export{a as default};
